import { Book, Calendar } from '@good/icons';
import { Center, SegmentedControl, Text } from '@good/ui/core';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { BookingsViewType } from './types';

interface BookingsViewToolbarViewControlProps {
  view: BookingsViewType;
  onChangeView: (view: BookingsViewType) => void;
}

export const BookingsViewToolbarViewControl = ({ view, onChangeView }: BookingsViewToolbarViewControlProps) => {
  const { t } = useTranslation('', { keyPrefix: 'bookings' });

  return (
    <SegmentedControl
      value={view}
      onChange={(view) => onChangeView(view as BookingsViewType)}
      size='sm'
      data={[
        {
          label: (
            <Center style={{ gap: 10 }} px='xs'>
              <Book />
              <Text inherit span fw={550}>
                List
              </Text>
            </Center>
          ),
          value: 'list',
        },
        {
          label: (
            <Center style={{ gap: 10 }} px='xs'>
              <Calendar />
              <Text inherit span fw={550}>
                {t('views.calendar')}
              </Text>
            </Center>
          ),
          value: 'calendar',
        },
      ]}
      fullWidth
    />
  );
};
